import React, { useState, useEffect } from "react";
import "./Navbar.css";
import { Link, useNavigate } from "react-router-dom";
import { isTokenValid } from "../Components/Auth";
import { toast } from "react-toastify";
import { connctDB } from "../ConnctDB";
import { useLiveQuery } from "dexie-react-hooks";
import allProducts from "../assets/images/Ap.jpg";
import allProductsWebp from "../assets/images/Ap.webp";
import businessCards from "../assets/images/bc.jpg";
import businessCardsWebp from "../assets/images/bc.webp";
import customCards from "../assets/images/cc.jpg";
import customCardsWebp from "../assets/images/cc.webp";
import pro from "../assets/images/pro.png";
import proWebp from "../assets/images/pro.webp";
import enterprise from "../assets/images/enterprise.png";
import enterpriseWebp from "../assets/images/enterprise.webp";
import faq from "../assets/images/faq.png";
import faqWebp from "../assets/images/faq.webp";
import contact from "../assets/images/contact.png";
import contactWebp from "../assets/images/contact.webp";
import blogs from "../assets/images/blogs.png";
import blogsWebp from "../assets/images/blogs.webp";
import basicCards from "../assets/images/basicc.jpg";
import basicCardsWebp from "../assets/images/basicc.webp";
import recycleCard from "../assets/images/rc.jpg";
import recycleCardWebp from "../assets/images/rc.webp";
import LocalImage from "./LocalImage";

const Navbar = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [authUser, setAuthUser] = useState(null);
  const [showDropDown, setShowDropDown] = useState(false);
  const [windowWidth, setWindowWidth] = useState();

  const navigate = useNavigate();

  const cartItemLength = useLiveQuery(() => connctDB.cart.count());

  const handleSignOutClick = () => {
    // Perform logout actions
    localStorage.removeItem("authToken");
    localStorage.removeItem("authUser");
    setAuthUser(null);
  
    toast.success("Signed out successfully!", {
      position: toast.POSITION.TOP_RIGHT,
      autoClose: 3000,
    });
  
    console.log("logout");
    navigate("/blogs");
    setIsLoggedIn(false);
  
    // Close the dropdown menu
    setShowDropDown(false);
  };

  useEffect(() => {
    const storedToken = localStorage.getItem("authToken");
    const authUser = localStorage.getItem("authUser");
    setAuthUser(authUser);
    const isValidToken = isTokenValid(storedToken);

    if (isValidToken) {
      setIsLoggedIn(true);
    } else {
      // Token is expired or invalid, log the user out
      localStorage.removeItem("authToken");
      localStorage.removeItem("authUser");
      setAuthUser(null);
      setIsLoggedIn(false);
    }
    setWindowWidth(window.innerWidth);
    window.addEventListener("resize", () => setWindowWidth(window.innerWidth));
    return window.addEventListener("resize", () =>
      setWindowWidth(window.innerWidth)
    );
  }, []);

  return (
    <>
      {windowWidth > 992 ? (
        <div
          className={
            showDropDown ? "discover-dropdown show" : "discover-dropdown"
          }
          key="1"
          onMouseLeave={() => setShowDropDown(false)}
        >
          <div className="container">
            <div className="left-container">
            <Link to="/product-list">
                <LocalImage
                  className="img-fluid"
                  src={allProducts}
                  webp={allProductsWebp}
                  alt="All Connct products"
                  width={925}
                  height={771}
                  style={{borderRadius:'10px', aspectRatio:'925 / 771'}}
                />
              </Link>
              <div className="line"></div>
              <Link to="/product-list">
                <LocalImage
                  className="img-fluid"
                  src={businessCards}
                  webp={businessCardsWebp}
                  alt="Business cards"
                  width={925}
                  height={771}
                  style={{borderRadius:'10px', aspectRatio:'925 / 771'}}
                />
              </Link>
              <div>
                <Link to="/product-list" state={{ dest: "basicCards" }}>
                  <LocalImage className="img-fluid" src={basicCards} webp={basicCardsWebp} alt="Basic cards" width={379} height={400} style={{borderRadius:'10px', aspectRatio:'379 / 400'}}/>
                </Link>
                <Link to="/product-list" state={{ dest: "customCards" }}>
                  <LocalImage
                    className="img-fluid"
                    src={customCards}
                    webp={customCardsWebp}
                    alt="Custom cards"
                    width={379}
                    height={400}
                    style={{marginTop:'5px',borderRadius:'10px', aspectRatio:'379 / 400'}}
                  />
                </Link>
              </div>
            </div>
            <div className="recycleCard">
              <LocalImage className="img-fluid" src={recycleCard} webp={recycleCardWebp} alt="Recycled cards" width={2183} height={788} style={{borderRadius:'10px', aspectRatio:'2183 / 788'}}/>
            </div>
          </div>
        </div>
      ) : (
        <div
          key="2"
          className={showDropDown ? "nav-dropdown show" : "nav-dropdown"}
        >
          <div className="container">
            <div className="large-cards">
              <Link to="/product-list" onClick={() => setShowDropDown(false)}>
                <LocalImage src={allProducts} webp={allProductsWebp} alt="All Connct products" width={925} height={771} />
              </Link>
              <div className="line"></div>
              <Link to="/product-list" onClick={() => setShowDropDown(false)}>
                <LocalImage src={businessCards} webp={businessCardsWebp} alt="Business cards" width={925} height={771} />
              </Link>
            </div>
            <div className="small-cards" onClick={() => setShowDropDown(false)}>
              <Link to="/product-list" state={{ dest: "basicCards" }}>
                <LocalImage src={basicCards} webp={basicCardsWebp} alt="Basic cards" width={379} height={400} />
              </Link>
              <Link
                to="/product-list"
                state={{ dest: "customCards" }}
                onClick={() => setShowDropDown(false)}
              >
                <LocalImage src={customCards} webp={customCardsWebp} alt="Custom cards" width={379} height={400} />
              </Link>
              <Link to="/upgrade-to-pro" onClick={() => setShowDropDown(false)}>
                <LocalImage src={pro} webp={proWebp} alt="Pro" width={102} height={107} />
              </Link>
              <Link to="/enterprise" onClick={() => setShowDropDown(false)}>
                <LocalImage src={enterprise} webp={enterpriseWebp} alt="Enterprise" width={110} height={115} />
              </Link>
              <Link to="/faq" onClick={() => setShowDropDown(false)}>
                <LocalImage src={faq} webp={faqWebp} alt="FAQ" width={102} height={107} />
              </Link>
              <Link to="/contact" onClick={() => setShowDropDown(false)}>
                <LocalImage src={contact} webp={contactWebp} alt="Contact" width={102} height={107} />
              </Link>
              <Link to="/blogs" onClick={() => setShowDropDown(false)}>
                <LocalImage src={blogs} webp={blogsWebp} alt="Blog" width={110} height={115} />
              </Link>
            </div>
            <div className="user">
              {isLoggedIn ? (
                <>
                  <li className="item user">
                    <div className="user-info">
                      <i
                        className="fa fa-user-circle"
                        aria-hidden="true"
                        style={{ fontSize: "29px", color: "#6E83B7" }}
                      ></i>
                      <div
                        className="user-options"
                        style={{ whiteSpace: "nowrap" }}
                      >
                 <Link to="#" onClick={handleSignOutClick}>
  Sign Out
</Link>
                        <br />
                        <Link
                          to="/forgot-password"
                          onClick={() => setShowDropDown(false)}
                        >
                          Forgot Password
                        </Link>
                      </div>
                    </div>
                    <div className="auth-user">{authUser}</div>
                  </li>
                </>
              ) : (
                <div className="item login" id="login">
                  <Link
                    to="/login"
                    className="login-link"
                    onClick={() => setShowDropDown(false)}
                  >
                    Login
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      <nav className="nav fixed">
        <div className="container">
          <div className="left-nav">
            <a className="navbar-brand" href="/">
              <LocalImage
                src={require("../assets/images/c.png")}
                webp={require("../assets/images/c.webp")}
                alt="Connct"
                className="logo-img"
                width={155}
                height={28}
                priority
                style={{ height: "28px", width: "155px" }}
              />
            </a>
            <ul className="navbar-main-nav" style={{ padding: 0, margin: 0 }}>
              <li className="item dropdown">
                <div
                  className="navbar-link"
                  style={{ cursor: "pointer" }}
                  onMouseEnter={() => setShowDropDown(true)}
                  onClick={() => setShowDropDown((prev) => !prev)}
                >
                  Discover
                </div>
              </li>
              <li className="item">
                <a
                  className={`navbar-link ${
                    window.location.pathname === "/upgrade-to-pro"
                      ? "active"
                      : ""
                  }`}
                  href="/upgrade-to-pro"
                >
                  <div
                    style={{
                      backgroundColor: "#fadb86",
                      borderRadius: "7px",
                      color: "white",
                      padding: "1px 8px",
                      display: "inline-block",
                      textDecoration: "none",
                      fontSize: "11px",
                    }}
                  >
                    Pro
                  </div>
                </a>
              </li>

              <li className="item">
                <a
                  className={`navbar-link ${
                    window.location.pathname === "/enterprise" ? "active" : ""
                  }`}
                  href="/enterprise"
                >
                  Enterprise
                  {window.location.pathname === "/enterprise" && <span></span>}
                </a>
              </li>

              <li className="item">
                <a
                  className={`navbar-link ${
                    window.location.pathname === "/faq" ? "active" : ""
                  }`}
                  href="/faq"
                >
                  FAQ
                </a>
              </li>

              <li className="item">
                <a
                  className={`navbar-link ${
                    window.location.pathname === "/contact" ? "active" : ""
                  }`}
                  href="/contact"
                >
                  Contact
                </a>
              </li>

              <li className="item">
                <a
                  className={`navbar-link ${
                    window.location.pathname === "/blogs" ? "active" : ""
                  }`}
                  href="/blogs"
                >
                  Blogs
                </a>
              </li>
            </ul>
          </div>
          <ul className="right-nav" style={{ padding: 0, margin: 0 }}>
            <li className="item" id="cart">
              <Link to="/shoppingcart" onClick={() => setShowDropDown(false)}>
                <LocalImage
                  src={require("../assets/images/cart.png")}
                  webp={require("../assets/images/cart.webp")}
                  alt="Cart"
                  width={24}
                  height={24}
                />
                {cartItemLength > 0 && (
                  <span className="badge">{cartItemLength}</span>
                )}
              </Link>
            </li>

            <li className="item ham-item">
              <button
                className="navbar-toggler"
                type="button"
                onClick={() => setShowDropDown((prev) => !prev)}
                aria-expanded={showDropDown}
                aria-controls="navbarSupportedContent"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-label="Toggle navigation"
              >
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
              </button>
            </li>
            {isLoggedIn ? (
              <>
                <li className="item user">
                  <div className="user-info">
                    <i
                      className="fa fa-user-circle"
                      aria-hidden="true"
                      style={{ fontSize: "29px", color: "#6E83B7" }}
                    ></i>
                    <div
                      className="user-options"
                      style={{ whiteSpace: "nowrap" }}
                    >
                  <Link to="#" onClick={handleSignOutClick}>
  Sign Out
</Link>
                      <br />
                      <Link to="/forgot-password">Forgot Password</Link>
                    </div>
                  </div>
                  <div className="auth-user">{authUser}</div>
                </li>
              </>
            ) : (
              <li className="item login" id="login">
                <Link to="/login" className="login-link">
                  Login
                </Link>
              </li>
            )}
          </ul>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
